/* STEEDIU PLUS — About page floating tools (Three.js)
   Real glTF wrench + screwdriver (blue matte handle via recoloured texture) plus a
   procedural machined screw. Studio environment matches the homepage +. Tools gently
   sway + float (no flat spin). Fails silent if WebGL/THREE/loader unavailable.
   Credits — Wrench: "Poly by Google" via Poly Pizza (CC-BY). Screwdriver: CC0. */
(function () {
  'use strict';

  function makeStudioEnv(renderer) {
    var c = document.createElement('canvas'); c.width = 256; c.height = 256;
    var x = c.getContext('2d');
    x.fillStyle = '#0a0b12'; x.fillRect(0, 0, 256, 256);
    x.filter = 'blur(11px)';
    x.fillStyle = '#f4f6fb'; x.fillRect(30, 16, 150, 66);
    x.fillStyle = '#cdd4e2'; x.fillRect(184, 64, 56, 86);
    x.fillStyle = '#9aa2b4'; x.fillRect(12, 150, 90, 24);
    var g = x.createLinearGradient(0, 150, 0, 256);
    g.addColorStop(0, 'rgba(40,44,60,0)'); g.addColorStop(1, 'rgba(120,126,146,0.45)');
    x.fillStyle = g; x.fillRect(0, 150, 256, 106);
    x.filter = 'none';
    var tex = new THREE.CanvasTexture(c);
    tex.mapping = THREE.EquirectangularReflectionMapping;
    var pm = new THREE.PMREMGenerator(renderer);
    var env = pm.fromEquirectangular(tex).texture;
    tex.dispose(); pm.dispose();
    return env;
  }

  // procedural machined screw: capped dome head + shaft + tapering helical threads + tip
  function buildScrew(mat) {
    var g = new THREE.Group();
    var m2 = mat.clone(); m2.side = THREE.DoubleSide;   // caps never read as hollow

    // pan head with a slightly DISHED top (concave centre + raised rim) so the drive
    // cross reads as a recess. Profile starts on the axis (x=0) so the pole is capped.
    var hp = [[0, 0.27], [0.16, 0.285], [0.32, 0.30], [0.45, 0.19], [0.49, 0.06], [0.45, -0.02], [0.18, -0.04]]
      .map(function (p) { return new THREE.Vector2(p[0], p[1]); });
    g.add(new THREE.Mesh(new THREE.LatheGeometry(hp, 72)));

    var shaftTop = -0.04, shaftBot = -2.0, tipLen = 0.5, tipPoint = shaftBot - tipLen;
    var shaft = new THREE.Mesh(new THREE.CylinderGeometry(0.16, 0.16, shaftTop - shaftBot, 48));
    shaft.position.y = (shaftTop + shaftBot) / 2; g.add(shaft);
    var tip = new THREE.Mesh(new THREE.ConeGeometry(0.16, tipLen, 48));
    tip.position.y = shaftBot - tipLen / 2; tip.rotation.x = Math.PI; g.add(tip);

    // threads: constant along the shaft, then taper to 0 following the tip (stop just above the point)
    var turns = 11, rMax = 0.2, yTop = -0.06, tipEnd = tipPoint + 0.05, seg = turns * 40, pts = [];
    for (var i = 0; i <= seg; i++) {
      var t = i / seg, y = yTop + (tipEnd - yTop) * t, a = t * turns * Math.PI * 2;
      var r = y >= shaftBot ? rMax : rMax * Math.max(0, (y - tipEnd) / (shaftBot - tipEnd));
      pts.push(new THREE.Vector3(Math.cos(a) * r, y, Math.sin(a) * r));
    }
    g.add(new THREE.Mesh(new THREE.TubeGeometry(new THREE.CatmullRomCurve3(pts), seg, 0.05, 14, false)));

    g.traverse(function (o) { if (o.isMesh) o.material = m2; });

    // Phillips "+" drive: dark cross inlaid into the dished head (reads as the recess)
    var drive = new THREE.MeshStandardMaterial({ color: 0x1b1d22, metalness: 0.5, roughness: 0.6, envMap: mat.envMap, envMapIntensity: 0.5 });
    var aL = 0.42, aW = 0.08, aT = 0.05, cy = 0.285;
    var b1 = new THREE.Mesh(new THREE.BoxGeometry(aL, aT, aW), drive);
    var b2 = new THREE.Mesh(new THREE.BoxGeometry(aW, aT, aL), drive);
    b1.position.y = cy; b2.position.y = cy; g.add(b1); g.add(b2);
    return g;
  }

  function normalize(root, targetSize) {
    var box = new THREE.Box3().setFromObject(root);
    var size = box.getSize(new THREE.Vector3());
    var center = box.getCenter(new THREE.Vector3());
    var maxDim = Math.max(size.x, size.y, size.z) || 1;
    root.position.sub(center);
    var wrap = new THREE.Group(); wrap.add(root);
    wrap.scale.setScalar(targetSize / maxDim);
    return wrap;
  }

  function init(mount) {
    if (!window.THREE || !THREE.GLTFLoader) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(27, 1, 0.1, 100);   // ~50mm (natural, low distortion)
    camera.position.set(0, 0, 13);

    var renderer;
    try { renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true }); }
    catch (e) { return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setClearColor(0x000000, 0);
    if ('outputEncoding' in renderer) renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.LinearToneMapping;
    renderer.toneMappingExposure = 0.9;
    mount.appendChild(renderer.domElement);

    var env = null;
    try { env = makeStudioEnv(renderer); scene.environment = env; } catch (e) { env = null; }

    scene.add(new THREE.AmbientLight(0xffffff, 0.34));
    var key = new THREE.DirectionalLight(0xffffff, 0.7); key.position.set(5, 6, 8); scene.add(key);
    var fill = new THREE.DirectionalLight(0xdfe4ff, 0.3); fill.position.set(-7, -2, 4); scene.add(fill);
    var rim = new THREE.DirectionalLight(0xffffff, 0.45); rim.position.set(0, 3, -6); scene.add(rim);

    var metal = new THREE.MeshPhysicalMaterial({
      color: 0xc6cad2, metalness: 0.92, roughness: 0.29,
      clearcoat: 0.4, clearcoatRoughness: 0.28, envMap: env, envMapIntensity: 1.05
    });
    // brand-blue matte handle
    var blueMat = new THREE.MeshStandardMaterial({ color: 0x0000fe, metalness: 0.0, roughness: 0.82, envMap: env, envMapIntensity: 0.35 });

    // Upgrade to real HDR image-based lighting (studio softboxes) — replaces the procedural
    // canvas env for cleaner metal reflections. Silently keeps the fallback if it fails.
    var hdrUrl = mount.getAttribute('data-hdr');
    if (hdrUrl && THREE.RGBELoader) {
      try {
        new THREE.RGBELoader().load(hdrUrl, function (tex) {
          try {
            tex.mapping = THREE.EquirectangularReflectionMapping;
            var pm = new THREE.PMREMGenerator(renderer);
            var hdrEnv = pm.fromEquirectangular(tex).texture;
            tex.dispose(); pm.dispose();
            scene.environment = hdrEnv;
            // repoint every tool material's reflections at the HDR (metal/blue are shared;
            // the screw body clone + drive cross are per-mesh, caught by the traverse)
            var seen = [];
            scene.traverse(function (o) {
              if (!o.isMesh || !o.material) return;
              (Array.isArray(o.material) ? o.material : [o.material]).forEach(function (m) {
                if (m && ('envMap' in m) && seen.indexOf(m) === -1) { seen.push(m); m.envMap = hdrEnv; m.needsUpdate = true; }
              });
            });
            metal.envMap = hdrEnv; metal.needsUpdate = true;
            blueMat.envMap = hdrEnv; blueMat.needsUpdate = true;
            if (env && env.dispose) env.dispose();
          } catch (e) {}
        }, undefined, function () { /* load error — keep procedural fallback */ });
      } catch (e) {}
    }

    var tools = [];
    function place(obj3d, cfg) {
      var norm = normalize(obj3d, cfg.size);
      var tool = new THREE.Group();
      tool.add(norm);
      scene.add(tool);
      tools.push({ o: tool, slot: cfg.slot, baseY: cfg.rx || 0, baseRz: cfg.rz || 0, ry: cfg.ry || 0,
                   phase: cfg.phase || 0, bob: cfg.bob || 0.3, y0: cfg.y || 0,
                   userY: 0, userX: 0, velY: 0, velX: 0 });
      layout();
    }

    // procedural screw (centre) — smaller than the two tools
    place(buildScrew(metal), { slot: 0, size: 1.9, rx: 0.35, ry: 0.4, rz: 0.4, phase: 2.0, y: -0.05, bob: 0.3 });

    var loader = new THREE.GLTFLoader();
    var A = mount.getAttribute('data-wrench'), B = mount.getAttribute('data-driver'), TX = mount.getAttribute('data-driver-tex');
    if (A) loader.load(A, function (g) {
      g.scene.traverse(function (o) { if (o.isMesh) o.material = metal; });
      // wrench lies flat (thin on Y) — face the camera, then angle diagonally so it's
      // narrower + taller (fits 3-across and fills the band on mobile)
      place(g.scene, { slot: -1, size: 3.8, rx: -1.4, ry: 0.12, rz: 0.92, phase: 0.0, y: 0.15, bob: 0.3 });
    }, undefined, function () {});
    if (B) loader.load(B, function (g) {
      // Split the single mesh by radius from its long axis: the fat part = handle (blue matte),
      // the thin part = shaft + tip (same metal as the wrench/screw).
      g.scene.traverse(function (o) {
        if (!o.isMesh) return;
        var geo = o.geometry; geo.computeBoundingBox();
        var size = new THREE.Vector3(), ctr = new THREE.Vector3();
        geo.boundingBox.getSize(size); geo.boundingBox.getCenter(ctr);
        var ax = (size.x >= size.y && size.x >= size.z) ? 0 : (size.y >= size.z ? 1 : 2);
        var pos = geo.getAttribute('position');
        function rad(i) {
          var d0, d1;
          if (ax === 0) { d0 = pos.getY(i) - ctr.y; d1 = pos.getZ(i) - ctr.z; }
          else if (ax === 1) { d0 = pos.getX(i) - ctr.x; d1 = pos.getZ(i) - ctr.z; }
          else { d0 = pos.getX(i) - ctr.x; d1 = pos.getY(i) - ctr.y; }
          return Math.sqrt(d0 * d0 + d1 * d1);
        }
        var maxR = 0, i; for (i = 0; i < pos.count; i++) { var r = rad(i); if (r > maxR) maxR = r; }
        var thr = maxR * 0.42, idx = geo.getIndex(), count = idx ? idx.count : pos.count, hf = [], mf = [];
        for (var f = 0; f < count; f += 3) {
          var a = idx ? idx.getX(f) : f, b = idx ? idx.getX(f + 1) : f + 1, c = idx ? idx.getX(f + 2) : f + 2;
          ((rad(a) + rad(b) + rad(c)) / 3 > thr ? hf : mf).push(a, b, c);
        }
        geo.setIndex(hf.concat(mf)); geo.clearGroups();
        geo.addGroup(0, hf.length, 0); geo.addGroup(hf.length, mf.length, 1);
        o.material = [blueMat, metal];
      });
      place(g.scene, { slot: 1, size: 3.8, rx: 0.2, ry: -0.4, rz: 0.95, phase: 3.4, y: 0.1, bob: 0.34 });
    }, undefined, function () {});

    // Grab any single tool and spin it freely. Picks the NEAREST tool to the pointer
    // (its whole region), so you don't have to land exactly on the mesh.
    var drag = null, lastX = 0, lastY = 0, _v = new THREE.Vector3();
    function pick(e) {
      var rect = renderer.domElement.getBoundingClientRect();
      var px = e.clientX - rect.left, py = e.clientY - rect.top, best = null, bestD = Infinity;
      for (var i = 0; i < tools.length; i++) {
        _v.set(tools[i].o.position.x, tools[i].o.position.y, 0).project(camera);
        var sx = (_v.x * 0.5 + 0.5) * rect.width, sy = (-_v.y * 0.5 + 0.5) * rect.height;
        var d = (sx - px) * (sx - px) + (sy - py) * (sy - py);
        if (d < bestD) { bestD = d; best = tools[i]; }
      }
      return best;
    }
    if (!reduced) {
      mount.style.pointerEvents = 'auto';
      mount.style.touchAction = 'pan-y';   // vertical swipe still scrolls the page
      mount.style.cursor = 'grab';
      mount.addEventListener('pointerdown', function (e) {
        var t = pick(e);
        if (t) { drag = t; t.velX = t.velY = 0; lastX = e.clientX; lastY = e.clientY; mount.style.cursor = 'grabbing';
          if (mount.setPointerCapture) { try { mount.setPointerCapture(e.pointerId); } catch (_) {} } }
      });
      mount.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - lastX, dy = e.clientY - lastY; lastX = e.clientX; lastY = e.clientY;
        drag.velY = dx * 0.011; drag.velX = dy * 0.009;
        drag.userY += drag.velY; drag.userX += drag.velX;
      });
      var rel = function () { drag = null; mount.style.cursor = 'grab'; };
      mount.addEventListener('pointerup', rel);
      mount.addEventListener('pointercancel', rel);
    }

    function layout() {
      var w = mount.clientWidth || 1, h = mount.clientHeight || 1;
      renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      var narrow = window.innerWidth <= 749;   // mobile, regardless of the band's aspect
      camera.position.z = narrow ? 7.4 : 12.7;   // pulled back to keep framing at the 27deg FOV
      var msc = narrow ? 0.8 : 1;
      var spread;
      if (narrow) { spread = 4.4; }
      else {
        // fit the spread to the (now narrower) column so the tools never clip at the edges
        var V = 2 * camera.position.z * Math.tan(27 * Math.PI / 360);
        spread = Math.max(2.0, Math.min(5.2, V * (w / h) * 0.5 - 2.6));
      }
      for (var i = 0; i < tools.length; i++) { tools[i].o.position.x = tools[i].slot * spread; tools[i].o.scale.setScalar(msc); }
      if (reduced) renderer.render(scene, camera);
    }

    var t0 = performance.now(), running = false, raf = 0;
    function frame(now) {
      if (!running) return;
      var t = now / 1000; t0 = now;
      for (var i = 0; i < tools.length; i++) {
        var T = tools[i];
        if (!reduced) {
          if (drag !== T) { T.userY += T.velY; T.userX += T.velX; T.velY *= 0.94; T.velX *= 0.92; }
          // gentle sway around a 3/4 presentation angle + any manual (dragged) spin
          T.o.rotation.y = T.ry + Math.sin(t * 0.45 + T.phase) * 0.6 + T.userY;
          T.o.rotation.x = T.baseY + Math.sin(t * 0.35 + T.phase) * 0.12 + T.userX;
          T.o.rotation.z = T.baseRz;
          T.o.position.y = T.y0 + Math.sin(t * 0.8 + T.phase) * T.bob;
        }
      }
      renderer.render(scene, camera);
      raf = requestAnimationFrame(frame);
    }
    function start() { if (running) return; running = true; t0 = performance.now(); raf = requestAnimationFrame(frame); }
    function stop() { running = false; if (raf) cancelAnimationFrame(raf); }

    if (!reduced) {
      start();
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      if (window.IntersectionObserver) new IntersectionObserver(function (e) { e[0].isIntersecting ? start() : stop(); }, { rootMargin: '200px' }).observe(mount);
    }
    if (window.ResizeObserver) new ResizeObserver(layout).observe(mount);
    else window.addEventListener('resize', layout);
  }

  function boot() {
    var mounts = document.querySelectorAll('[data-ab-tools]');
    for (var i = 0; i < mounts.length; i++) init(mounts[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
